import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import Footer from "../components/Footer";
import OurServices from "../components/sections/OurServices";
import SectionHome from "../components/sections/SectionHome";
import OurTestimonials from "../components/sections/OurTestimonials";
// import FeaturedContentFull from "../components/sections/FeaturedContentFull";
import HomeAboutUs from "../components/sections/HomeAboutUs";
import Header from "../components/Header";
import WordCloud from "../components/sections/WordCloud";

const backgroundImages = [
  "/images/home.jpg",
  "/images/home-2.jpg",
  //
];

const getRandomIndex = () => {
  return Math.floor(Math.random() * backgroundImages.length);
};

const Home = () => {
  // refs
  const sectionMainRef = useRef(null);

  const refTestimonials = useRef(null);
  const refBigPicture = useRef(null);
  const refAboutUs = useRef(null);
  const refFeaturedContent = useRef(null);
  const refWordCloud = useRef(null);
  const refOurQuality = useRef(null);
  const refOurServices = useRef(null);
  const refContact = useRef(null);
  const refCTATitle = useRef(null);
  const refFooter = useRef(null);

  // controls
  const controlsTestimonials = useAnimation();
  // const controlsBigPicture = useAnimation();
  const controlsAboutUs = useAnimation();
  const controlsFeaturedContent = useAnimation();
  const controlsWordCloud = useAnimation();
  const controlsOurQuality = useAnimation();
  const controlsOurServices = useAnimation();
  const controlsContact = useAnimation();
  const controlsCTATitle = useAnimation();
  const controlsFooter = useAnimation();

  // states
  const [showScrollDownButton, setShowScrollDownButton] = useState(true);

  const [animatedTestimonials, setanimatedTestimonials] = useState(false);
  // const [animatedBigPicture, setanimatedBigPicture] = useState(false);
  const [animatedAboutUs, setanimatedAboutUs] = useState(false);
  const [animatedFeaturedContent, setanimatedFeaturedContent] = useState(false);
  const [animatedWordCloud, setanimatedWordCloud] = useState(false);
  const [animatedOurQuality, setanimatedOurQuality] = useState(false);
  const [animatedOurServices, setanimatedOurServices] = useState(false);
  const [animatedContact, setanimatedContact] = useState(false);
  const [animatedCTATitle, setanimatedCTATitle] = useState(false);
  const [animatedFooter, setanimatedFooter] = useState(false);

  // ======================================================================== //
  // 🟩 Effects
  // ========================================================================  //
  // 🟩 Effects

  const [backgroundImage, setBackgroundImage] = useState("");

  useEffect(() => {
    const randomIndex = getRandomIndex();
    const randomImage = backgroundImages[randomIndex];
    setBackgroundImage(randomImage);

    // Cleanup function (optional)
    return () => {
      // Perform any cleanup or unsubscribe logic if needed
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!animatedTestimonials && refTestimonials.current) {
        const getTopValue = refTestimonials.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsTestimonials.start("visible");
          setanimatedTestimonials(true);
        }
      }

      if (!animatedAboutUs && refAboutUs.current) {
        const getTopValue = refAboutUs.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsAboutUs.start("visible");
          setanimatedAboutUs(true);
        }
      }

      if (!animatedFeaturedContent && refFeaturedContent.current) {
        const getTopValue = refFeaturedContent.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsFeaturedContent.start("visible");
          setanimatedFeaturedContent(true);
        }
      }

      if (!animatedWordCloud && refWordCloud.current) {
        const getTopValue = refWordCloud.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsWordCloud.start("visible");
          setanimatedWordCloud(true);
        }
      }

      if (!animatedOurQuality && refOurQuality.current) {
        const getTopValue = refOurQuality.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsOurQuality.start("visible");
          setanimatedOurQuality(true);
        }
      }

      if (!animatedOurServices && refOurServices.current) {
        const getTopValue = refOurServices.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsOurServices.start("visible");
          setanimatedOurServices(true);
        }
      }

      if (!animatedContact && refContact.current) {
        const getTopValue = refContact.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsContact.start("visible");
          setanimatedContact(true);
        }
      }

      if (!animatedCTATitle && refCTATitle.current) {
        const getTopValue = refCTATitle.current.getBoundingClientRect().top;
        const threshold = window.innerHeight / 2;

        if (getTopValue < threshold) {
          controlsCTATitle.start("visible");
          setanimatedCTATitle(true);
        }
      }

      if (!animatedFooter && refFooter.current) {
        const getTopValue = refFooter.current.getBoundingClientRect().top;
        const threshold = window.innerHeight - 200;

        if (getTopValue < threshold) {
          controlsFooter.start("visible");
          setanimatedFooter(true);
        }
      }

      //
      // Scroll button
      //
      const currentScrollY = window.scrollY;
      // console.log(currentScrollY);

      if (currentScrollY > 200) {
        setShowScrollDownButton(false);
      } else {
        setShowScrollDownButton(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [
    animatedTestimonials,
    // animatedBigPicture,
    animatedAboutUs,
    animatedFeaturedContent,
    animatedWordCloud,
    animatedOurQuality,
    animatedOurServices,
    animatedContact,
    animatedCTATitle,
    animatedFooter,
    controlsTestimonials,
    // controlsBigPicture,
    controlsAboutUs,
    controlsFeaturedContent,
    controlsWordCloud,
    controlsOurQuality,
    controlsOurServices,
    controlsContact,
    controlsCTATitle,
    controlsFooter,
  ]);

  // ======================================================================== //
  // 🟨 Functions

  const scrollToBelowSection = () => {
    // example: scrolling to Why Us section

    if (refOurQuality.current) {
      refOurQuality.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  //
  // # Home Page Sections
  // - Logo and slogan
  // - Why us
  // - Experience
  // - Quality
  // - Services
  // - Testimonials
  // - Partners
  // - Stats
  // - Footer (contact us)
  //

  return (
    <div ref={sectionMainRef} className="h-screen w-full">
      <Header showLogo={false} />

      {/*                            */}
      {/* 🟥 Logo and slogan         */}
      {/*                            */}
      <motion.section ref={refBigPicture}>
        <SectionHome randomBackgroundImage={backgroundImage} />
      </motion.section>

      {/*                            */}
      {/* 🟩 Our Services            */}
      {/*                            */}
      <motion.section
        ref={refOurQuality}
        initial="hidden"
        animate={controlsOurQuality}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{ duration: 0.5 }}
        className="flex justify-center items-center bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080"><g transform=" rotate(191 960 540) translate(-308.00944821906046 -173.25531462322147) scale(1.320843175228188) "><rect width="1920" height="1080" fill="rgb(222, 222, 222)"></rect><g transform="translate(0, 0)"><path fill="rgb(233, 233, 233)" fill-opacity="1" d="M0,352.943L80,350.075C160,347.207,320,341.471,480,340.581C640,339.692,800,343.65,960,344.095C1120,344.54,1280,341.472,1440,303.183C1600,264.894,1760,191.383,1840,154.628L1920,117.873L1920,1080L1840,1080C1760,1080,1600,1080,1440,1080C1280,1080,1120,1080,960,1080C800,1080,640,1080,480,1080C320,1080,160,1080,80,1080L0,1080Z"></path></g><g transform="translate(0, 360)"><path fill="rgb(244, 244, 244)" fill-opacity="1" d="M0,301.154L80,251.883C160,202.612,320,104.069,480,98.48C640,92.892,800,180.258,960,202.019C1120,223.78,1280,179.937,1440,139.356C1600,98.774,1760,61.455,1840,42.796L1920,24.136L1920,720L1840,720C1760,720,1600,720,1440,720C1280,720,1120,720,960,720C800,720,640,720,480,720C320,720,160,720,80,720L0,720Z"></path></g><g transform="translate(0, 720)"><path fill="rgb(255, 255, 255)" fill-opacity="1" d="M0,251.675L80,227.428C160,203.181,320,154.687,480,130.414C640,106.141,800,106.09,960,141.274C1120,176.458,1280,246.877,1440,284.697C1600,322.517,1760,327.739,1840,330.349L1920,332.96L1920,360L1840,360C1760,360,1600,360,1440,360C1280,360,1120,360,960,360C800,360,640,360,480,360C320,360,160,360,80,360L0,360Z"></path></g></g></svg>')`,
        }}
      >
        <OurServices />
      </motion.section>

      {/*                            */}
      {/* 🟩 About Us                */}
      {/*                            */}
      <motion.section
        ref={refAboutUs}
        initial="hidden"
        animate={controlsAboutUs}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{ duration: 0.5 }}
        className="flex justify-center items-center bg-gradient-to-b from-primary-600 to-primary-400"
      >
        <HomeAboutUs />
      </motion.section>

      {/*                            */}
      {/* 🟩 Testimonials            */}
      {/*                            */}
      <motion.section
        ref={refTestimonials}
        initial="hidden"
        animate={controlsTestimonials}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{ duration: 0.5 }}
        className="flex justify-center items-center bg-gradient-to-b from-primary-300 to-primary-400"
      >
        <OurTestimonials />
      </motion.section>

      {/*                            */}
      {/* 🟩 Featured Content Full   */}
      {/*                            */}
      {/* <motion.section
        ref={refFeaturedContent}
        initial="hidden"
        animate={controlsFeaturedContent}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{ duration: 0.5 }}
      >
        <FeaturedContentFull />
      </motion.section> */}

      {/*                            */}
      {/* 🟩 Word Cloud              */}
      {/*                            */}
      <motion.section
        ref={refWordCloud}
        initial="hidden"
        animate={controlsWordCloud}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{ duration: 0.5 }}
      >
        <WordCloud />
      </motion.section>

      {/*                            */}
      {/* 🟩 Footer                  */}
      {/*                            */}
      <motion.section
        ref={refFooter}
        initial="hidden"
        animate={controlsFooter}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{ duration: 0.5 }}
        className="flex justify-center items-center bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080"><g transform=" rotate(194 960 540) translate(-384.36393238172263 -216.20471196471897) scale(1.400379096230961) "><rect width="1920" height="1080" fill="rgb(252, 102, 1)"></rect><g transform="translate(0, 0)"><path fill="rgb(253, 114, 21)" fill-opacity="1" d="M0,264.707L64,262.556C128,260.405,256,256.103,384,255.436C512,254.769,640,257.737,768,258.071C896,258.405,1024,256.104,1152,227.387C1280,198.67,1408,143.537,1536,138.881C1664,134.225,1792,180.045,1856,202.956L1920,225.866L1920,1080L1856,1080C1792,1080,1664,1080,1536,1080C1408,1080,1280,1080,1152,1080C1024,1080,896,1080,768,1080C640,1080,512,1080,384,1080C256,1080,128,1080,64,1080L0,1080Z"></path></g><g transform="translate(0, 270)"><path fill="rgb(254, 126, 40)" fill-opacity="1" d="M0,4.145L64,36.907C128,69.669,256,135.193,384,151.514C512,167.835,640,134.953,768,104.517C896,74.081,1024,46.091,1152,60.539C1280,74.987,1408,131.872,1536,142.129C1664,152.386,1792,116.015,1856,97.83L1920,79.644L1920,810L1856,810C1792,810,1664,810,1536,810C1408,810,1280,810,1152,810C1024,810,896,810,768,810C640,810,512,810,384,810C256,810,128,810,64,810L0,810Z"></path></g><g transform="translate(0, 540)"><path fill="rgb(254, 138, 60)" fill-opacity="1" d="M0,79.529L64,105.937C128,132.344,256,185.158,384,213.523C512,241.888,640,245.804,768,213.506C896,181.208,1024,112.697,1152,84.467C1280,56.237,1408,68.289,1536,94.704C1664,121.12,1792,161.899,1856,182.289L1920,202.679L1920,540L1856,540C1792,540,1664,540,1536,540C1408,540,1280,540,1152,540C1024,540,896,540,768,540C640,540,512,540,384,540C256,540,128,540,64,540L0,540Z"></path></g><g transform="translate(0, 810)"><path fill="rgb(255, 150, 79)" fill-opacity="1" d="M0,253.429L64,233.844C128,214.259,256,175.089,384,135.235C512,95.38,640,54.842,768,32.523C896,10.205,1024,6.106,1152,30.809C1280,55.513,1408,109.018,1536,125.837C1664,142.655,1792,122.785,1856,112.85L1920,102.916L1920,270L1856,270C1792,270,1664,270,1536,270C1408,270,1280,270,1152,270C1024,270,896,270,768,270C640,270,512,270,384,270C256,270,128,270,64,270L0,270Z"></path></g></g></svg>')`,
        }}
      >
        <Footer />
      </motion.section>

      {/*                            */}
      {/* 🟨 Button                  */}
      {/*                            */}
      {showScrollDownButton && (
        <div className="fixed right-10 bottom-10">
          <motion.button
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
            onClick={scrollToBelowSection}
            className="cursor-pointer"
          >
            <svg
              width="48px"
              height="48px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: "48px", height: "48px" }}
            >
              <path
                d="M5 15C5 16.8565 5.73754 18.6371 7.05029 19.9498C8.36305 21.2626 10.1435 21.9999 12 21.9999C13.8565 21.9999 15.637 21.2626 16.9498 19.9498C18.2625 18.6371 19 16.8565 19 15V9C19 7.14348 18.2625 5.36305 16.9498 4.05029C15.637 2.73754 13.8565 2 12 2C10.1435 2 8.36305 2.73754 7.05029 4.05029C5.73754 5.36305 5 7.14348 5 9V15Z"
                stroke="#FFFFFF"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M12 6V14" stroke="#FFFFFF" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15 11L12 14L9 11" stroke="#FFFFFF" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </motion.button>
        </div>
      )}
    </div>
  );
};

export default Home;
